import { Button, HStack, Text } from '@chakra-ui/react';
import { FC } from 'react';

interface Props {
  amount: string;
  askAmount: number;
  currencySymbol: string;
  onClick: (amount: string) => any;
}

const AskButton: FC<Props> = ({ amount, askAmount, currencySymbol, onClick }) => {
  return (
    <Button
      h={50}
      // w={70}
      w="full"
      // borderRadius="50%"
      borderWidth="1px"
      fontWeight="medium"
      {...(amount == askAmount.toString()
        ? {
            // checked
            borderColor: 'primary.500',
            backgroundColor: 'primary.500',
            // color: 'blackAlpha.700',
            color: 'white',
            _hover: {},
          }
        : {
            borderColor: 'blackAlpha.400',
            backgroundColor: 'white',
            // color: 'blackAlpha.700',
            color: 'primary.500',
            _hover: {
              backgroundColor: 'white',
              color: 'primary.500',
              borderColor: 'primary.500',
            },
          })}
      key={askAmount}
      onClick={() => onClick(askAmount.toString())}
    >
      <HStack align="baseline" spacing={0}>
        <Text fontSize={15}>{currencySymbol}</Text>
        <Text fontSize={20}>{askAmount}</Text>
      </HStack>
    </Button>
  );
};

export default AskButton;
